import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService, CoreTypes, FormValidatorService, IncidentTypes, Modal } from 'common-cloudstudio';
import { GearAppService } from 'common-gear';
import { IncidentService } from '../../services/incident.service';
import { IncidentVehiclesInvolvedComponent } from './Incident-vehicles-involved/Incident-vehicles-involved.component';

@Component({
  selector: 'app-incident-element-modal',
  templateUrl: './incident-element-modal.component.html',
  styleUrls: ['./incident-element-modal.component.scss']
})
export class IncidentElementModalComponent  implements OnInit {
  @ViewChild('modal') private _modal: Modal;
  @ViewChild('formElement') private _formElement: NgForm;
  @ViewChild('vehicleElement') _vehicleElementModal: IncidentVehiclesInvolvedComponent;

  @Output() onClose = new EventEmitter<boolean>();
  @Output() dataChange = new EventEmitter<any>();
  public parameters: IncidentTypes.IncidentElementModal;
  public parametersClone: IncidentTypes.IncidentElementModal;
  public parametersPeopleClone: IncidentTypes.IncidentElementModal;
  private _data: IncidentTypes.IncidentElementModal;
  @Input() set data(value: any) {
    this._data = value;
    this.parameters = JSON.parse(JSON.stringify(value));
    this.onChangeData(value);
  }

  get data(): IncidentTypes.IncidentElementModal {
    return this._data;
  }
  incidentElementTypes = IncidentTypes.elementTypes;
  private closeBySave = false;
  errorMessage: string = null;
  isNewElement: boolean = true;
  formStatus = 0;
  disabledForm: boolean = false;
  isOpen = false;
  materialAssetsFullList: CoreTypes.ITS_MaterialAssets[] = [];
  debounceUpdate;

  constructor(
    public appService: AppService,
    public gearAppService: GearAppService,
    public formValidatorService: FormValidatorService,
    private cdRef:ChangeDetectorRef,
    private incidentService: IncidentService,
  ) { }

  ngOnInit(): void { }

  async open(args?: any) {
    this.parametersClone = null;
    this.parametersPeopleClone = null;
    this._modal.open(args);
    setTimeout(() => this._modal.modalRoot.nativeElement.querySelector('label')?.focus(), 300);
    this.isOpen = true;
    this.closeBySave = false;
    setTimeout(() => {
      if(this.parameters?.IncidentElementTypeID === this.incidentElementTypes.InvolvedVehicles) {
        this.parametersClone = JSON.parse(JSON.stringify(this.parameters));
        if(this.parameters.Editing){
          setTimeout(() => this._vehicleElementModal?.setDisabledState(true), 100);
        }
      }
      if(this.parameters?.IncidentElementTypeID === this.incidentElementTypes.InvolvedPeople) {
        this.parametersPeopleClone = JSON.parse(JSON.stringify(this.parameters)); 
      }
    }, 500);
  }
  
  onCloseModal() {
    if (!this.closeBySave) { this.onClose.emit(true); }

    setTimeout(() => {
      this.formStatus = 0;
      this.parameters = JSON.parse(JSON.stringify(this.data));
      this.isNewElement = false;
      this.disabledForm = false;
    }, 300);
    this.isOpen = false;
  }

  onChangeData(value) {
    if (this.parameters?.IncidentElementTypeID === this.incidentElementTypes.DamageRegister) {
      this.getMaterialAssetsList();
    }
  }

  onDisabledForm(event) {
    this.disabledForm = event;
    this.cdRef.detectChanges()
  }

  getMaterialAssetsList() {
    this.materialAssetsFullList = [];
    this.incidentService.getIncidentMaterialAssets().then(data => {
      this.materialAssetsFullList = data;
    });
  }
  
  licenseExist(item: any): boolean {
    return this.incidentService.isItemSelectedInSection(this.incidentElementTypes.InvolvedVehicles, item);
  }

  peopleExist(item: any): boolean {
    return this.incidentService.isItemSelectedInSection(this.incidentElementTypes.InvolvedPeople, item);
  }

  save() {
    this.errorMessage = '';
    if(this._formElement.form.invalid) {
      const getErrorMessage = this.formValidatorService.getValidationErrors(this._formElement);
      this.errorMessage = getErrorMessage;
      return;
    }
    this.disabledForm = true;

    if(this.parameters.IncidentElementTypeID === this.incidentElementTypes.InvolvedVehicles) {
      let vehicle = JSON.parse(JSON.stringify(this.parameters?.JsonData));
      let vehicleClone = JSON.parse(JSON.stringify(this.parametersClone));
      let vehicleExist = this.licenseExist(vehicle.LicensePlate);
      if(vehicleExist && (!this.parameters.Editing || (vehicleClone?.LicensePlate && vehicle.LicensePlate !== vehicleClone.LicensePlate))) {
        this.errorMessage = "Este vehículo ya ha sido agregado. No se permiten duplicados";
        return;
      }
      let result: CoreTypes.ITS_VehicleSimplifiedData = this.setVehicleSimpleData(vehicle);
      this.updateITSVehicle(vehicle?.VehicleDataID, result, this.parameters);
    }

    if(this.parameters.IncidentElementTypeID === this.incidentElementTypes.InvolvedPeople) { 
      let people: CoreTypes.ITS_Persons = JSON.parse(JSON.stringify(this.parameters.JsonData));
      let peopleClone = JSON.parse(JSON.stringify(this.parametersPeopleClone));
      let peopleExist = this.peopleExist(people?.DocumentNumber);
      if(peopleExist && (!this.parameters.Editing || (peopleClone?.DocumentNumber && people.DocumentNumber !== peopleClone.DocumentNumber))) {
        this.errorMessage = "Esta persona ya ha sido agregada. No se permiten duplicados";
        return;
      }
      let result: CoreTypes.ITS_Persons = this.setPeopleData(people);
      this.updateITSPerson(result, this.parameters);
    }
    
    setTimeout(() => {
      if(this.parameters.IncidentElementTypeID !== this.incidentElementTypes.InvolvedPeople &&
        this.parameters.IncidentElementTypeID !== this.incidentElementTypes.InvolvedVehicles
      ){
        this.dataChange.emit(this.parameters);
      }
      
      this.closeBySave = true;
      this._modal.close();
      this.onClose.emit(false);
      this.disabledForm = false;
    }, 300);

  }
  
  setPeopleData(objOrigin) {
    let person: CoreTypes.ITS_Persons = {
      ContactAddress: objOrigin.ContactAddress,
      ContactCity: objOrigin.ContactCity,
      ContactPhone: objOrigin.ContactPhone,
      CountryID: objOrigin.CountryID,
      DocumentNumber: objOrigin.DocumentNumber,
      DocumentTypeID: objOrigin.DocumentTypeID,
      Email: objOrigin.Email,
      FirstName: objOrigin.FirstName,
      GenderID: objOrigin.GenderID,
      HasEmptyInformation: objOrigin.HasEmptyInformation,
      InsuranceCompanyID: objOrigin.InsuranceCompanyID,
      InsuranceIsValid: objOrigin.InsuranceIsValid,
      InsurancePolicy: objOrigin.InsurancePolicy,
      InsurancePolicyEffectiveSince: objOrigin.InsurancePolicyEffectiveSince,
      InsurancePolicyValidUntil: objOrigin.InsurancePolicyValidUntil,
      LastName: objOrigin.LastName,
      NeedConfirmName: objOrigin.NeedConfirmName,
      NeedToBeUpdated: objOrigin.NeedToBeUpdated,
      PersonID: objOrigin.PersonID
    }
    return person;
  }

  updateITSPerson(data:CoreTypes.ITS_Persons, parameters) {
    if(data && data?.PersonID) {
      this.incidentService.updateITSPerson(data.PersonID, data).then((result) => {
        let params = JSON.parse(JSON.stringify(parameters));
        let people = JSON.parse(JSON.stringify(parameters?.JsonData));
        people = Object.assign(people, result);
        params.JsonData = JSON.parse(JSON.stringify(people));
        this.dataChange.emit(params);
        this.disabledForm = false;
      }).catch(_ => {
        this.disabledForm = false;
        this.dataChange.emit(parameters);
      });
    } else {
      this.dataChange.emit(parameters);
    }
  }

  setVehicleSimpleData(objOrigin:CoreTypes.ITS_VehicleSimplifiedData) {
    let person: CoreTypes.ITS_VehicleSimplifiedData = {
      ColorID: objOrigin.ColorID,
      Email: objOrigin.Email,
      InsuranceCompanyID: objOrigin.InsuranceCompanyID,
      InsurancePolicy: objOrigin.InsurancePolicy,
      InsurancePolicyEffectiveSince: objOrigin.InsurancePolicyEffectiveSince,
      InsurancePolicyValidUntil: objOrigin.InsurancePolicyValidUntil,
      LicensePlate: objOrigin.LicensePlate,
      MobilePhone: objOrigin.MobilePhone,
      ModelID: objOrigin.ModelID,
      ModelName: objOrigin.ModelName,
      Notes: objOrigin.Notes,
      VehicleMakeID: objOrigin.VehicleMakeID,
      VehicleOwnerID: objOrigin.VehicleOwnerID,
      VehicleType: objOrigin.VehicleType,
      VehicleYear: objOrigin.VehicleYear,
    }
    return person;
  }

  updateITSVehicle(vehicleID:number, data: CoreTypes.ITS_VehicleSimplifiedData, parameters) {
    if(data && vehicleID) {
      this.incidentService.updateITSVehicleData(vehicleID, data).then((result) => {
        let params =  JSON.parse(JSON.stringify(parameters));
        let vehicle = JSON.parse(JSON.stringify(parameters?.JsonData));
        vehicle = Object.assign(vehicle, result);
        params.JsonData = JSON.parse(JSON.stringify(vehicle));
        this.dataChange.emit(params);
        this.disabledForm = false;
      }).catch(_ => {
        this.dataChange.emit(parameters);
        this.disabledForm = false;
      });
    } else {
      this.dataChange.emit(parameters);
    }
  }
}
